<div class="modal-main">
  <div
    class="header d-flex justify-content-center align-items-center position-relative pt-3 pb-3 px-4"
  >
    <h1 class="modal-title mb-0">{{ "DELETE_ACCOUNT" | translate }}</h1>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button position-absolute pointer-cursor"
      (click)="closeDialog()"
    />
  </div>

  <div class="content">
    <div class="success-icon-container">
      <img
        src="/assets/svg/ico-completed-check.svg"
        alt="account deletion submitted"
        class="success-icon"
      />
    </div>

    <h2 class="success-title">
      {{ "ACCOUNT_DELETION_SUBMITTED" | translate }}
    </h2>

    <div class="info-box">
      <span class="info-icon">&#9432;</span>
      <p class="info-text">
        {{ "ACCOUNT_DELETION_INFO" | translate }}
      </p>
    </div>
  </div>

  <div class="popup-footer"></div>
</div>
